<template>
  <div class="big-number">
    <el-tooltip
      class="item"
      effect="dark"
      :content="number*100 + '%'"
      placement="top"
    >
      <span>{{showNumber}}</span>
    </el-tooltip>
  </div>
</template>

<script>
import { fixed } from "@/utils/bigNumberTran.js"
export default {
  props: {
    number: {
      type: [Number, String, Object],
      default: () => {
        return 0;
      }
    },
    count: {
      type: [Number, String, Object],
      default: () => {
        return 2;
      }
    },
  },
  data() {
    return {};
  },
  computed: {
    showNumber(){
      return fixed((this.number*100 || 0),this.count);
    }

  },
  methods: {
  },
  created() {},
  watch: {}
};
</script>
<style scoped lang="scss">
.big-number{
  display: inline-block;
  font-size: 0.2rem;
}
</style>
